/**
 * @generated SignedSource<<61095b937bb7e061ff1ad7a42449ace1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RootWorkspaceQuery$variables = {
  piece_id: string;
};
export type RootWorkspaceQuery$data = {
  readonly music_viewer: {
    readonly piece: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"NoteSelectWorkspace_piece" | "StaffSelectWorkspace_piece">;
    };
  };
};
export type RootWorkspaceQuery = {
  variables: RootWorkspaceQuery$variables;
  response: RootWorkspaceQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "piece_id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "piece_id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "x",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "y",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "finder_confidence",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "has_dot",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "confidence",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mask_download_url",
  "storageKey": null
},
v13 = [
  (v2/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RootWorkspaceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NoteSelectWorkspace_piece"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "StaffSelectWorkspace_piece"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RootWorkspaceQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MusicViewer",
        "kind": "LinkedField",
        "name": "music_viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MusicSheet",
                "kind": "LinkedField",
                "name": "sheets",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": "note_combine_steps",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "step_type",
                        "value": "NOTE_DATA_SOURCE_COMBINE"
                      }
                    ],
                    "concreteType": "MusicParseStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MusicParseStepDataNoteDataSourceCombineNote",
                                "kind": "LinkedField",
                                "name": "notes",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "note_id",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MusicParseStepDataNoteDataSourceCombineNoteDisplayable",
                                    "kind": "LinkedField",
                                    "name": "note_types_in_order_of_likelihood_displayable",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "note_type",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "title",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "is_audible",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MusicParseStepDataNoteDataSourceCombineNoteBarInformation",
                                    "kind": "LinkedField",
                                    "name": "bar_information",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "total_number_of_vertical_lines",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "MusicParseStepDataNoteDataSourceCombineNoteBulb",
                                    "kind": "LinkedField",
                                    "name": "bulbs",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "bulb_id",
                                        "storageKey": null
                                      },
                                      (v5/*: any*/),
                                      (v6/*: any*/),
                                      (v8/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "alias": "median_spacing",
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "median_spacing_between_lines",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "line_placement",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MusicParseStepDataNoteDataSourceCombineNoteBulbBarInformation",
                                        "kind": "LinkedField",
                                        "name": "bar_information",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "bar_note_line_idx",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "bar_note_number_of_top_lines",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "MusicParseStepDataNoteBulbLineFinderAndPlacerBulbLine",
                                        "kind": "LinkedField",
                                        "name": "main_lines",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "a",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "b",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "back_accessory_types_in_order_or_likelihood",
                                        "storageKey": null
                                      },
                                      (v11/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MusicParseStepDataNoteDataSourceCombineSharpFlatNatural",
                                "kind": "LinkedField",
                                "name": "sharp_flat_naturals",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v8/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "type",
                                    "storageKey": null
                                  },
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "placement",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MusicParseStepDataNoteDataSourceCombine",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "steps(step_type:\"NOTE_DATA_SOURCE_COMBINE\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "thumbnail_download_url",
                    "storageKey": null
                  },
                  (v8/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": "tie_finder_steps",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "step_type",
                        "value": "MUSIC_TIE_FINDER"
                      }
                    ],
                    "concreteType": "MusicParseStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MusicParseStepDataTieFinderTie",
                                "kind": "LinkedField",
                                "name": "ties",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "start_x",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "start_y",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "end_x",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "end_y",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MusicParseStepDataTieFinder",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "steps(step_type:\"MUSIC_TIE_FINDER\")"
                  },
                  {
                    "alias": "bar_line_processor_steps",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "step_type",
                        "value": "BAR_LINE_PROCESSOR"
                      }
                    ],
                    "concreteType": "MusicParseStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MusicParseStepDataBarLineProcessorMask",
                                "kind": "LinkedField",
                                "name": "masks",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": "key",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mask_storage_name",
                                    "storageKey": null
                                  },
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MusicParseStepDataBarLineProcessor",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "steps(step_type:\"BAR_LINE_PROCESSOR\")"
                  },
                  {
                    "alias": "note_finder_user_confirmation_steps",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "step_type",
                        "value": "NOTE_USER_CONFIRMATION"
                      }
                    ],
                    "concreteType": "MusicParseStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": (v13/*: any*/),
                    "storageKey": "steps(step_type:\"NOTE_USER_CONFIRMATION\")"
                  },
                  {
                    "alias": "bar_finder_steps",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "step_type",
                        "value": "BAR_FINDER"
                      }
                    ],
                    "concreteType": "MusicParseStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MusicParseStepDataBarFinderBar",
                                "kind": "LinkedField",
                                "name": "bars",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": "bar_id",
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "mask_storage_name",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v8/*: any*/),
                                  (v7/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MusicParseStepDataBarFinder",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "steps(step_type:\"BAR_FINDER\")"
                  },
                  {
                    "alias": "bar_finder_user_confirmation_steps",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "step_type",
                        "value": "BAR_FINDER_USER_CONFIRMATION"
                      }
                    ],
                    "concreteType": "MusicParseStep",
                    "kind": "LinkedField",
                    "name": "steps",
                    "plural": true,
                    "selections": (v13/*: any*/),
                    "storageKey": "steps(step_type:\"BAR_FINDER_USER_CONFIRMATION\")"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3cead080ce9770d310b1aa63d2d1f37e",
    "id": null,
    "metadata": {},
    "name": "RootWorkspaceQuery",
    "operationKind": "query",
    "text": "query RootWorkspaceQuery(\n  $piece_id: ID!\n) {\n  music_viewer {\n    piece(id: $piece_id) {\n      id\n      ...NoteSelectWorkspace_piece\n      ...StaffSelectWorkspace_piece\n    }\n  }\n}\n\nfragment NoteFinderPageBarLineMask_mask on MusicParseStepDataBarLineProcessorMask {\n  mask_download_url\n}\n\nfragment NoteFinderPageOverlayNoteBulb_Bulb on MusicParseStepDataNoteDataSourceCombineNoteBulb {\n  bulb_id\n  x\n  y\n  width\n  height\n  confidence\n  has_dot\n  main_lines {\n    a\n    b\n  }\n}\n\nfragment NoteFinderPageOverlayNote_Note on MusicParseStepDataNoteDataSourceCombineNote {\n  note_id\n  x\n  y\n  height\n  width\n  finder_confidence\n  has_dot\n  note_types_in_order_of_likelihood_displayable {\n    note_type\n    title\n    is_audible\n  }\n  bar_information {\n    total_number_of_vertical_lines\n  }\n  bulbs {\n    bulb_id\n    x\n    y\n    width\n    height\n    median_spacing: median_spacing_between_lines\n    line_placement\n    bar_information {\n      bar_note_line_idx\n      bar_note_number_of_top_lines\n    }\n    main_lines {\n      a\n      b\n    }\n    back_accessory_types_in_order_or_likelihood\n    ...NoteFinderPageOverlayNoteBulb_Bulb\n  }\n}\n\nfragment NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural on MusicParseStepDataNoteDataSourceCombineSharpFlatNatural {\n  id\n  x\n  y\n  width\n  height\n  type\n  finder_confidence\n  placement\n}\n\nfragment NoteFinderPageOverlayTie_Tie on MusicParseStepDataTieFinderTie {\n  start_x\n  start_y\n  end_x\n  end_y\n  id\n}\n\nfragment NoteFinderPageOverlay_sheet on MusicSheet {\n  id\n  width\n  height\n  tie_finder_steps: steps(step_type: MUSIC_TIE_FINDER) {\n    id\n    data {\n      __typename\n      ... on MusicParseStepDataTieFinder {\n        ties {\n          id\n          ...NoteFinderPageOverlayTie_Tie\n        }\n      }\n    }\n  }\n  bar_line_processor_steps: steps(step_type: BAR_LINE_PROCESSOR) {\n    id\n    status\n    data {\n      __typename\n      ... on MusicParseStepDataBarLineProcessor {\n        masks {\n          key: mask_storage_name\n          ...NoteFinderPageBarLineMask_mask\n        }\n      }\n    }\n  }\n  note_combine_steps: steps(step_type: NOTE_DATA_SOURCE_COMBINE) {\n    id\n    status\n    data {\n      __typename\n      ... on MusicParseStepDataNoteDataSourceCombine {\n        notes {\n          note_id\n          ...NoteFinderPageOverlayNote_Note\n        }\n        sharp_flat_naturals {\n          id\n          ...NoteFinderPageOverlaySharpFlatNatural_sharpFlatNatural\n        }\n      }\n    }\n  }\n}\n\nfragment NoteFinderPageTools_sheet on MusicSheet {\n  id\n  note_combine_steps: steps(step_type: NOTE_DATA_SOURCE_COMBINE) {\n    id\n    status\n    data {\n      __typename\n      ... on MusicParseStepDataNoteDataSourceCombine {\n        notes {\n          note_id\n          ...NoteFinderPageOverlayNote_Note\n        }\n      }\n    }\n  }\n  note_finder_user_confirmation_steps: steps(step_type: NOTE_USER_CONFIRMATION) {\n    id\n    status\n  }\n}\n\nfragment NoteFinderPage_sheet on MusicSheet {\n  id\n  thumbnail_download_url\n  ...NoteFinderPageOverlay_sheet\n  ...NoteFinderPageTools_sheet\n}\n\nfragment NoteSelectWorkspace_piece on MusicPiece {\n  id\n  sheets {\n    id\n    note_combine_steps: steps(step_type: NOTE_DATA_SOURCE_COMBINE) {\n      id\n      status\n    }\n    ...NoteFinderPage_sheet\n  }\n}\n\nfragment StaffSelectPageMask_barFinderBar on MusicParseStepDataBarFinderBar {\n  bar_id: mask_storage_name\n  confidence\n  mask_download_url\n}\n\nfragment StaffSelectPageOverlay_sheet on MusicSheet {\n  id\n  width\n  height\n  bar_finder_steps: steps(step_type: BAR_FINDER) {\n    id\n    status\n    data {\n      __typename\n      ... on MusicParseStepDataBarFinder {\n        bars {\n          bar_id: mask_storage_name\n          x\n          y\n          width\n          height\n          ...StaffSelectPageMask_barFinderBar\n        }\n      }\n    }\n  }\n  bar_finder_user_confirmation_steps: steps(step_type: BAR_FINDER_USER_CONFIRMATION) {\n    id\n    status\n  }\n}\n\nfragment StaffSelectPageTools_sheet on MusicSheet {\n  id\n  bar_finder_user_confirmation_steps: steps(step_type: BAR_FINDER_USER_CONFIRMATION) {\n    id\n  }\n  bar_finder_steps: steps(step_type: BAR_FINDER) {\n    id\n    data {\n      __typename\n      ... on MusicParseStepDataBarFinder {\n        bars {\n          bar_id: mask_storage_name\n        }\n      }\n    }\n  }\n}\n\nfragment StaffSelectPage_sheet on MusicSheet {\n  id\n  thumbnail_download_url\n  ...StaffSelectPageOverlay_sheet\n  ...StaffSelectPageTools_sheet\n}\n\nfragment StaffSelectWorkspace_piece on MusicPiece {\n  id\n  sheets {\n    id\n    ...StaffSelectPage_sheet\n    bar_finder_steps: steps(step_type: BAR_FINDER) {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c4095a65499b377e3e0d68300d8c9bdf";

export default node;
